import { Component, Host, Input, input, Optional } from '@angular/core';
import { ExpansionPanelComponent } from '../expansion-panel.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@nagel-assests';

@Component({
    selector: 'lib-expansion-panel-header',
    templateUrl: './expansion-panel-header.component.html',
    styleUrl: './expansion-panel-header.component.scss',
    imports: [MatIconModule, IconComponent, CommonModule]
})
export class ExpansionPanelHeaderComponent {
    @Input() onPinToggle: () => void = () => {};
    @Input() isPinned: boolean = false;
    constructor(
    @Host() @Optional() public parentPanel: ExpansionPanelComponent
    ) {}

    toggleParent() {
        this.parentPanel?.switchTogglestate();
    }

    getToggleButtonClass() {
        return this.isParentToggled() ? 'header-icon-button flipped-button' : 'header-icon-button';
    }

    isParentToggled() {
        return this.parentPanel?.isToggled ?? false;
    }

    keypressHandler(event: KeyboardEvent) {
        if (event.key === 'Enter' || event.key === ' ') {
            this.toggleParent();
        }
    }
}